/** Parse calendar date parts from ISO or YYYY-MM-DD without timezone shifts. */
function parseCalendarDate(
  dateOfBirth?: string | null
): { year: number; month: number; day: number } | undefined {
  if (!dateOfBirth?.trim()) return undefined;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateOfBirth.trim());
  if (!match) return undefined;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
    return undefined;
  }
  if (month < 1 || month > 12 || day < 1 || day > 31) return undefined;
  return { year, month, day };
}

/** Parse ISO or YYYY-MM-DD date of birth into birth year. */
export function parseBirthYear(dateOfBirth?: string | null): number | undefined {
  return parseCalendarDate(dateOfBirth)?.year;
}

/** Age in full years on the given date (defaults to today). */
export function currentAge(dateOfBirth?: string | null, asOf = new Date()): number | undefined {
  const birth = parseCalendarDate(dateOfBirth);
  if (!birth) return undefined;
  let age = asOf.getFullYear() - birth.year;
  const monthDiff = asOf.getMonth() + 1 - birth.month;
  if (monthDiff < 0 || (monthDiff === 0 && asOf.getDate() < birth.day)) {
    age -= 1;
  }
  return age;
}

export function retirementCalendarYear(birthYear: number, retirementAge: number): number {
  return birthYear + retirementAge;
}

export function birthYearFromAge(age: number, asOfYear = new Date().getFullYear()): number {
  return asOfYear - age;
}
